
import {
    FETCH_MESSAGES_SUCCESS,
    FETCH_MESSAGES_ERROR,
    FETCH_MESSAGES_LOADING,

    RESET_MESSAGES,
    FETCH_MORE_MESSAGES_SUCCESS,
    FETCH_MORE_MESSAGES_LOADING,

    SET_CHAT_MESSAGE,
    SET_CHAT_PHONE_NO,
    FETCH_CHAT_LOADING,
    FETCH_CHAT_SUCCESS,
    FETCH_CHAT_ERROR,
    SEND_MESSAGE_LOCAL,
    
    UPDATE_NOTES_MESSAGE,

    FETCH_CHAT_UNREAD_COUNT_SUCCESS,
    FETCH_RESPONSE_COUNT_SUCCESS,
    FETCH_RESPONSIBLE_LIST_SUCCESS,

    FETCH_ALL_MESSAGES_SUCCESS,
    FETCH_ALL_MORE_MESSAGES_SUCCESS,

    FETCH_CONVERSATION_AI_STATUS_SUCCESS,
    UPDATE_CONVERSATION_AI_STATUS_SUCCESS,

} from "../action/index" 

import {platform} from '../../functions/utils'

const defaultState= {
    data: [],
    all_data: {},
    error: null,
    isLoading: false,
    meta: [],
    isMoreLoading: false,

    chat_message: "",
    chat_isLoading: false,
    chat_data: [],
    chat_phone_no: false,

    unread_count_data: [],
    response_count_data: [],
    responsible_list_data: [],

    conversation_ai_enabled: true,
    conversation_ai_loading: false,

}

const messageReducer = (state = defaultState, action ) => {
    let dupState = {...state}
    switch(action.type){
        case FETCH_ALL_MESSAGES_SUCCESS:
            return {...state, all_data: action.payload, isLoading: false, isMoreLoading:false, error: null}
        case FETCH_MESSAGES_SUCCESS:
            return {...state, data: action.payload, isLoading: false, isMoreLoading:false, error: null, meta: action.meta}
        case FETCH_CHAT_UNREAD_COUNT_SUCCESS:
            return {...state, unread_count_data: action.payload}
        case FETCH_RESPONSE_COUNT_SUCCESS:
            return {...state, response_count_data: action.payload}
        case FETCH_RESPONSIBLE_LIST_SUCCESS:
            return {...state, responsible_list_data: action.payload}
        case FETCH_MESSAGES_LOADING:
            return {...state, isLoading: true, isMoreLoading: true, error: null}
        case FETCH_MESSAGES_ERROR:
            return {...state, isLoading: false, error: "FETCH_MESSAGES_ERROR"}
        case RESET_MESSAGES:
            return {...state, data: [], isLoading: true, meta: []}
        case FETCH_MORE_MESSAGES_LOADING:
            return {...state, isMoreLoading: true}
        case FETCH_MORE_MESSAGES_SUCCESS:
            return {...state, data: dupState.data.concat( action.payload ), isLoading: false, error: null, meta: action.meta, isMoreLoading: false}
        case FETCH_ALL_MORE_MESSAGES_SUCCESS:
            return {...state, all_data: action.payload, isLoading: false, error: null, isMoreLoading: false}
        case SET_CHAT_MESSAGE:
            return {...state, chat_message: action.payload}
        case SET_CHAT_PHONE_NO:
            return {...state, chat_phone_no: action.payload, chat_data: [], chat_isLoading: true, conversation_ai_enabled: true}
        case FETCH_CHAT_LOADING:
            return {...state, chat_isLoading: true}
        case FETCH_CHAT_SUCCESS:
            return {...state, chat_isLoading: false, chat_data: action.payload}
        case FETCH_CHAT_ERROR:
            return {...state, chat_isLoading: false, chat_data: []}
        case SEND_MESSAGE_LOCAL:
            let chat_data= dupState.chat_data
            if( platform == "web" ){
                chat_data.push(action.payload)
            }else{
                chat_data.unshift(action.payload)
            }
            return {...state, chat_data }
        case UPDATE_NOTES_MESSAGE:
            let data = dupState.data
            let target = data.find( x => x.id === action.payload.id );
            target.note = action.payload.note
            return {...state, data}

        case "FETCH_CONVERSATION_AI_STATUS_LOADING":
            return {
                ...state,
                conversation_ai_loading: true,
            };

            case "FETCH_CONVERSATION_AI_STATUS_SUCCESS":
            return {
                ...state,
                conversation_ai_enabled: action.payload,
                conversation_ai_loading: false,
            };

            case "UPDATE_CONVERSATION_AI_STATUS_LOADING":
            return {
                ...state,
                conversation_ai_loading: true,
            };

            case "UPDATE_CONVERSATION_AI_STATUS_SUCCESS":
            return {
                ...state,
                conversation_ai_enabled: action.payload,
                conversation_ai_loading: false,
            };


        default:
            return {...state};
    }
}

export default messageReducer;